module.exports = __webpack_public_path__ + "img/2.58f51d42.png";